import { Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useCancelClientInviteMutation } from "@/redux/apis/client/clientApi";
import { addToast } from "@/utils";
import { useClientsContext } from "../context";
import { ClientsConfirmStep } from "./ClientsConfirmStep";

interface ClientsCancelInviteProps {
  onClose: () => void;
}

/** Confirm step before cancelling (revoking) a pending client's invitation (Figma 11234-10123). */
export const ClientsCancelInvite = ({ onClose }: ClientsCancelInviteProps) => {
  const { selectedClient } = useClientsContext();
  const [cancelClientInvite, { isLoading }] = useCancelClientInviteMutation();

  const onConfirm = () => {
    if (!selectedClient) return;

    cancelClientInvite(selectedClient.id)
      .unwrap()
      .then(() => {
        addToast("success", `Invitation cancelled for ${selectedClient.email}`);
        onClose();
      })
      .catch((e) => getErrorMessages(e).forEach((m) => addToast("danger", m)));
  };

  return (
    <ClientsConfirmStep
      title="Cancel Invitation"
      confirmLabel="Cancel Invitation"
      cancelLabel="Keep Invitation"
      danger
      isLoading={isLoading}
      onConfirm={onConfirm}
      onClose={onClose}
    >
      <Typography variant="paragraph">
        Are you sure you want to cancel <span className="text-primary">{selectedClient?.name}</span>&apos;s invitation to RideMinder?
      </Typography>
      <Typography variant="paragraph">They won&apos;t be able to join unless you invite them again.</Typography>
    </ClientsConfirmStep>
  );
};
